export { Page, type PageProps } from "./Page";
